<template>
  <div>
    <v-app-bar color="transparent" dense flat>
      <v-toolbar-title style="max-width: 60%">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              class="mr-6"
              :to="{
                name: 'survey',
              }"
              @click="
                $router.push({
                  name: 'survey',
                })
              "
              >keyboard_double_arrow_left</v-icon
            >
          </template>
          <span>กลับหน้าแรก</span> </v-tooltip
        ><span>{{ $route.params.surveyName }}</span></v-toolbar-title
      >

      <v-spacer></v-spacer>
      <v-btn
        class="mx-2"
        color="#2A9CD4"
        small
        icon
        @click="toggle_formconfig = !toggle_formconfig"
        ><v-icon>palette</v-icon></v-btn
      >
      <span v-if="exist_form.updated_date" class="font-italic"
        ><h6>
          แก้ไขครั้งล่าสุด :
          {{ $store.getters.datetimeConvertShort(exist_form.updated_date) }}
        </h6></span
      >
      <v-btn class="mx-2 white--text" color="#2A9CD4" @click="UpdateSurvey">
        บันทึก
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      :style="SwitchBGImage"
      left
      permanent
      touchless
      disable-resize-watcher
      width="100%"
    >
      <v-layout style="align-items: center">
        <v-container style="height: 100vh">
          <v-card
            flat
            color="transparent"
            width="100%"
            class="d-flex justify-center"
            style="padding-bottom: 140px"
          >
            <v-card
              flat
              color="transparent"
              :width="mobile_mode ? 375 : '100%'"
            >
              <div v-show="tabs === 'welcome'">
                <div style="display: contents">
                  <v-card
                    flat
                    width="100%"
                    height="100%"
                    class="d-flex justify-center align-center"
                    color="transparent"
                    v-if="welcome_theme"
                  >
                    <AuthForm
                      :config="true"
                      :welcome_theme="welcome_theme"
                      :allow_webform="allow_webform"
                      :range_status="range_status"
                      :surveyInfo="exist_form"
                      :mobile_mode="mobile_mode"
                    />
                  </v-card>
                </div>
              </div>
              <QuestionForm
                v-show="tabs === 'question'"
                :config="true"
                :webform_theme="webform_theme"
                :qselect="qselect"
                :surveyInfo="exist_form"
                :mobile_mode="mobile_mode"
              />
              <EndForm
                v-show="tabs === 'endform'"
                :config="true"
                :endform_theme="endform_theme"
                :mobile_mode="mobile_mode"
                :qselect="qselect"
              />
            </v-card>
          </v-card>
        </v-container>
      </v-layout>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="toggle_formconfig"
      class="px-2 pb-6"
      height="100vh"
      style="font-size: 13px; z-index: 0"
      app
      touchless
      clipped
      :permanent="toggle_formconfig"
      right
      width="370"
    >
      <v-card flat color="transparent" class="py-3">
        <v-tabs v-model="tabs" hide-slider fixed-tabs>
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#welcome"> เริ่มต้น </v-tab>

          <v-tab href="#question"> คำถาม </v-tab>

          <v-tab href="#endform"> จบคำถาม </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item value="welcome" class="px-1">
            <v-btn @click="mobile_mode = !mobile_mode" icon
              ><v-icon>{{
                mobile_mode ? "smartphone" : "computer"
              }}</v-icon></v-btn
            >แสดงผลในรูปแบบ {{ mobile_mode ? "Mobile" : "PC" }}
            <v-divider class="my-2"></v-divider>
            <ConfigWelcome
              v-if="welcome_theme"
              :welcome_theme="welcome_theme"
              :selected.sync="login_selected"
              :mobile_mode="mobile_mode"
            />
          </v-tab-item>
          <v-tab-item value="question" class="py-6 px-1">
            <v-row no-gutters>
              <v-col cols="10" class="grow">
                <v-select
                  v-model="qselect"
                  :items="[...storeQuestion.connect]"
                  label="คำถาม"
                  outlined
                  hide-details
                  attach
                  item-value="questionID"
                  item-text="questionLabel"
                >
                  <template #item="{ item }">
                    {{ item.indexing + 1 }}.
                    {{
                      item.questionLabel.length > 35
                        ? `${item.questionLabel.substring(0, 35)}...`
                        : item.questionLabel
                    }}
                  </template>
                </v-select></v-col
              >
              <v-col cols="2" class="shirnk d-flex align-center justify-center">
                <v-btn @click="mobile_mode = !mobile_mode" icon
                  ><v-icon>{{
                    mobile_mode ? "smartphone" : "computer"
                  }}</v-icon></v-btn
                >
              </v-col>
            </v-row>
            <ConfigQuestion
              :webform_theme="webform_theme"
              :qselect_type="qselect_type"
            />
          </v-tab-item>
          <v-tab-item value="endform" class="py-6 px-1">
            <v-row no-gutters>
              <v-col cols="10" class="grow">
                <v-select
                  v-model="qselect"
                  :items="[...storeQuestion.end]"
                  label="จบคำถาม"
                  outlined
                  hide-details
                  attach
                  item-value="questionID"
                  item-text="questionLabel"
                >
                  <template #item="{ item }">
                    {{
                      item.questionLabel.length > 35
                        ? `${item.questionLabel.substring(0, 35)}...`
                        : item.questionLabel
                    }}
                  </template>
                </v-select></v-col
              >
              <v-col cols="2" class="shirnk d-flex align-center justify-center"
                ><v-btn @click="mobile_mode = !mobile_mode" icon
                  ><v-icon>{{
                    mobile_mode ? "smartphone" : "computer"
                  }}</v-icon></v-btn
                ></v-col
              >
            </v-row>
            <ConfigEndForm :endform_theme="endform_theme" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import QuestionForm from "../../components/FormUI/QuestionForm.vue";
import EndForm from "../../components/FormUI/EndForm.vue";
import AuthForm from "../../components/FormUI/AuthForm.vue";
import ConfigQuestion from "./Config/ConfigQuestion.vue";
import ConfigEndForm from "./Config/ConfigEndForm.vue";
import ConfigWelcome from "./Config/ConfigWelcome.vue";
export default {
  components: {
    QuestionForm,
    EndForm,
    ConfigQuestion,
    ConfigEndForm,
    ConfigWelcome,
    AuthForm,
  },
  data: () => ({
    toggle_formconfig: true,
    questionInfo: null,
    answer: "",
    formend: false,
    endmsg: [],
    login_type: [
      {
        text: "ปกติ",
        value: "normal",
      },
      {
        text: "Login with OneID",
        value: "oneid",
      },
      {
        text: "เข้ามาก่อนเวลา",
        value: "early",
      },
      {
        text: "เข้ามาหลังหมดเวลา",
        value: "end",
      },
      {
        text: "ปิดรับคำตอบ",
        value: "closed",
      },
    ],
    login_selected: "normal",
    allow_webform: true,
    range_status: "",
    qselect: "",
    qselect_type: "",
    mobile_mode: false,
    exist_form: {},
    exist_setting: {},
    tabs: "welcome",
    webform_theme: {
      bg_color: "#FBFBFBFF",
      bg_image: false,
      bg_image_url: "",
      bg_repeat: "repeat",
      bg_position_x: "left",
      bg_position_y: "top",
      bg_size: "auto",
      header_bg: "#395DA5FF",
      header_text: "#FFFFFFFF",
      title: "",
      subtitle: "",
      logo: false,
      logo_type: "normal",
      banner_size: 100,
      logo_image: {
        url: "",
        size: 50,
        rounded: "circle",
        align: "center",
        margin: true,
      },
      checkbox_row: false,
      radio_row: false,
      q_bgcolor: "#FFFFFFFF",
      q_text_color: "#000000",
      q_border_px: 1,
      q_border_color: "#0000001f",
      ans_color: "#395da5",
      ans_bgcolor: "#FFFFFFFF",
      ans_text_color: "#000000",
      ans_border_px: 1,
      ans_border_color: "#0000001f",
      button: {
        bg_color: "#395DA5FF",
        text: "ถัดไป >>",
        text_color: "#FFFFFFFF",
        bt_texttype: "button",
      },
      restart_button: {
        bg_color: "#395DA5FF",
        text: "เริ่มใหม่",
        text_color: "#395DA5",
        bt_texttype: "outlined",
      },
    },
    welcome_theme: null,
    endform_theme: {
      bg_color: "#FBFBFBFF",
      bg_image: false,
      bg_image_url: "",
      bg_repeat: "repeat",
      bg_position_x: "left",
      bg_position_y: "top",
      bg_size: "auto",
      image: false,
      image_url:
        "https://chatme04.chatme.co.th/CMStorage/endform_1628063085970.png",
      image_size: 400,
      text_color: "#000000",
      text_justify: "center",
      text_size: 30,
      button: {
        bg_color: "#395DA5FF",
        text: "ทำแบบทดสอบอีกครั้ง",
        text_color: "#FFFFFFFF",
        bt_texttype: "button",
        bt_block: false,
        bt_rounded: false,
      },
    },
  }),
  beforeCreate() {
    this.$store.dispatch("CheckPermission").then((resp_role) => {
      if (resp_role.data.permission) {
        if (Object.keys(resp_role.data.permission).length !== 0) {
          this.$store.commit("UpdateUserPermission", resp_role.data);
          if (resp_role.data.permission.survey.update) {
            this.$store.dispatch("getPermission");
            this.$store.dispatch("getRole");
            this.getSurveyByID();
          } else {
            Swal.fire({
              icon: "error",
              text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
              title: "",
            }).then(() => {
              this.$router.push({
                name: "question",
              });
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
            title: "",
          }).then(() => {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            this.$router.push({
              name: "question",
            });
          });
        }
      }
    });
  },
  computed: {
    storeQuestion() {
      let allquestion = this.$store.state.allquestion;
      let connect = [];
      let end = [];
      let fail = [];
      allquestion.map((question) => {
        switch (question.questionType) {
          case "fail":
            {
              fail.push(question);
            }
            break;
          case "end":
            {
              end.push(question);
            }
            break;

          default:
            {
              connect.push(question);
            }
            break;
        }
      });
      connect.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      end.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      fail.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      if (!this.questionInfo) {
        if (connect[0]) {
          this.getQuestion(connect[0].questionID);
        }
      }
      return { connect: connect, end: end, fail: fail };
    },
    Survey() {
      if (this.$route.params.surveyID) {
        return this.$store.state.surveylist.find(
          (suid) => suid.surveyID === this.$route.params.surveyID
        );
      }
      return null;
    },
    SwitchBGImage() {
      if (this.webform_theme && this.welcome_theme && this.endform_theme) {
        switch (this.tabs) {
          case "welcome":
            return `background-color: ${this.welcome_theme.bg_color}; ${
              this.welcome_theme.bg_image
                ? `background-image: url(${this.welcome_theme.bg_image_url});
               background-repeat:${this.welcome_theme.bg_repeat};
               background-size:${this.welcome_theme.bg_size};
               background-position: ${this.welcome_theme.bg_position_x} ${this.welcome_theme.bg_position_y};
               `
                : ""
            }`;

          case "question":
            return `background-color: ${this.webform_theme.bg_color}; ${
              this.webform_theme.bg_image
                ? `background-image: url(${this.webform_theme.bg_image_url});
               background-repeat:${this.webform_theme.bg_repeat};
               background-size:${this.webform_theme.bg_size};
               background-position: ${this.webform_theme.bg_position_x} ${this.webform_theme.bg_position_y};
               `
                : ""
            }`;

          case "endform":
            return `background-color: ${this.endform_theme.bg_color}; ${
              this.endform_theme.bg_image
                ? `background-image: url(${this.endform_theme.bg_image_url});
               background-repeat:${this.endform_theme.bg_repeat};
               background-size:${this.endform_theme.bg_size};
               background-position: ${this.endform_theme.bg_position_x} ${this.endform_theme.bg_position_y};
               `
                : ""
            }`;
        }
      }
      return null;
    },
  },
  watch: {
    qselect(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getQuestion(newValue);
      }
    },
    tabs(newValue, oldValue) {
      if (oldValue && newValue) {
        if (newValue === "question") {
          this.getQuestion(this.storeQuestion.connect[0].questionID);
        } else if (newValue === "endform") {
          this.getQuestion(this.storeQuestion.end[0].questionID);
        }
      }
    },
    login_selected(newValue, oldValue) {
      if (oldValue && newValue) {
        // console.log(newValue);
        switch (newValue) {
          case "normal":
            {
              this.allow_webform = true;
              this.range_status = "";
              this.exist_form.enableAuth = false;
              this.exist_form.surveyStatus = true;
            }
            break;
          case "oneid":
            {
              this.allow_webform = true;
              this.range_status = "";
              this.exist_form.enableAuth = true;
              this.exist_form.surveyStatus = true;
            }
            break;
          case "early":
            {
              this.allow_webform = false;
              this.range_status = "early";
              this.exist_form.enableAuth = false;
              this.exist_form.surveyStatus = true;
            }
            break;
          case "end":
            {
              this.allow_webform = false;
              this.range_status = "end";
              this.exist_form.enableAuth = false;
              this.exist_form.surveyStatus = true;
            }
            break;
          case "closed":
            {
              this.allow_webform = true;
              this.range_status = "";
              this.exist_form.enableAuth = false;
              this.exist_form.surveyStatus = false;
            }
            break;
        }
      }
    },
  },
  methods: {
    getSurveyByID() {
      this.$store
        .dispatch("getSurveyByID", this.$route.params.surveyID)
        .then((response) => {
          // console.log(response.data);
          this.exist_form = JSON.parse(JSON.stringify(response.data));
          this.exist_setting = JSON.parse(JSON.stringify(response.data));
          this.exist_form.enableAuth = false;
          this.exist_form.surveyStatus = true;
          this.allow_webform = true;
          this.range_status = "";
          if (response.data.webform_theme) {
            switch (this.login_selected) {
              case "normal":
                {
                  this.allow_webform = true;
                  this.range_status = "";
                  this.exist_form.enableAuth = false;
                  this.exist_form.surveyStatus = true;
                }
                break;
              case "oneid":
                {
                  this.allow_webform = true;
                  this.range_status = "";
                  this.exist_form.enableAuth = true;
                  this.exist_form.surveyStatus = true;
                }
                break;
              case "early":
                {
                  this.allow_webform = false;
                  this.range_status = "early";
                  this.exist_form.enableAuth = false;
                  this.exist_form.surveyStatus = true;
                }
                break;
              case "end":
                {
                  this.allow_webform = false;
                  this.range_status = "end";
                  this.exist_form.enableAuth = false;
                  this.exist_form.surveyStatus = true;
                }
                break;
              case "closed":
                {
                  this.allow_webform = true;
                  this.range_status = "";
                  this.exist_form.enableAuth = false;
                  this.exist_form.surveyStatus = false;
                }
                break;
            }
            if (response.data.webform_theme.q_bgcolor) {
              this.webform_theme = response.data.webform_theme;
            }
          }
          if (response.data.endform_theme) {
            this.endform_theme = response.data.endform_theme;
          }
          if (response.data.welcome_theme) {
            this.welcome_theme = response.data.welcome_theme;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            text: "ไม่สามารถดึงข้อมูล survey ได้",
            title: "",
          });
        });
    },
    getQuestion(qid) {
      if (qid) {
        this.qselect = qid;
        let api = {
          method: "get",
          url: `${process.env.VUE_APP_API}/manageSurvey/survey/${this.$route.params.surveyID}/question/questioninfo/${qid}`,
          data: {},
        };
        this.$store.getters.SendAPIWithHeader(api).then((response) => {
          this.qselect_type = response.data.conditionType;
          if (
            response.data.questionType === "connect" ||
            response.data.questionType === "start"
          ) {
            if (response.data.conditionType === "multiselect") {
              response.data.conditionsAnswer.match = [
                response.data.conditionsAnswer.match[0],
              ];
              this.questionInfo = response.data;
            } else {
              this.questionInfo = response.data;
            }
            this.formend = false;
          } else {
            this.formend = true;
            this.endmsg = response.data.questions;
          }
        });
      }
    },
    UpdateSurvey() {
      this.$store.commit("ToggleButtonLoading");
      let exist_form = {
        ...this.exist_setting,
        webform_theme: this.webform_theme,
        welcome_theme: this.welcome_theme,
        endform_theme: this.endform_theme,
      };
      console.log(exist_form);
      this.$store
        .dispatch("UpdateSurvey", exist_form)
        .then(() => {
          Swal.fire({
            icon: "success",
            text: "แก้ไขเรียบร้อยแล้ว",
            title: "",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.getSurveyByID();
            this.$store.commit("ToggleButtonLoading");
          });
        })
        .catch((err) => {
          let errMsg =
            err.data.message === "Permission Denied"
              ? "คุณไม่มีสิทธิ์แก้ไขฟอร์ม"
              : "ไม่สามารถแก้ไขฟอร์มได้";
          Swal.fire({
            icon: "error",
            text: errMsg,
            title: "",
          }).then(() => {
            this.$store.dispatch("getSurvey");
            this.$store.commit("ToggleLoading");
            if (err.data.message === "Permission Denied") {
              this.$store
                .dispatch("getQuestionPermission", this.$route.params.surveyID)
                .then(() => {
                  this.$router.push({
                    name: "question",
                  });
                });
            }
          });
        });
    },
  },
};
</script>
